import React from 'react'
import './Footer.css'
import GitHub from '../../assets/github.png'
import instagram from '../../assets/instagram.png'
import linkedIn from '../../assets/linkedin.png'
import Logo from '../../assets/logo.png'

const Footer = () => {
  return (
    <div className="footer-container">
        <div className="blur footer-blur-1"></div>
        <div className="blur footer-blur-2"></div>
        <hr />
        <div className="footer">
            <div className="social-links">
                <img src={GitHub} alt="" />
                <img src={instagram} alt="" />
                <img src={linkedIn} alt="" />
            </div>
            <div className="logo-f">
                <img src={Logo} alt="" />
            </div>
        </div>
    </div>
  )
}

export default Footer
